export default {
    benefitsCities: state => {
        return state.benefitsCities }
}



// WEBPACK FOOTER //
// ./src/store/modules/popupciudad/getters.js